import { Modal } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { createFieldInput, createFieldSelect } from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import router from "../../../../../router";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { createFieldDesc } from "../tab-1/tab1.section";
import { callDocumentTypePerson, callUserRequestStatus, callUserRequestType, createFieldUser2 } from "../tab-4/tab4.section";

const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));
const AttachmentInlineList = defineAsyncComponent(() => import("../../../../../components/attachment/AttachmentInlineList"));

export const callUserRequestDoc3Attachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_REQUEST_DOC_3_ATTACHMENT", value: searchQuery });
export const callUserCommittee = ({ searchQuery, parentUsername }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refUser.username", type: "String", operator: "=", value: parentUsername }
    ];
    if (searchQuery) {
        where.push({ name: "fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/userCommittee/search", {
            criteria: {
                select: ["id", "fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "fullNameTh", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};
export const callUserCommitteeFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/userCommittee/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    { name: "attachments", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = () => {
    return [
        createColumnInput({
            title: () => i18n.global.t("model.userCommittee.refPosition"),
            dataIndex: "refUserCommitteeTemp.refPosition",
            dataIndexValue: () => i18n.global.t("views.company.mgt.tab.3.refPosition"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            width: 130
        }),
        createColumnInput({ title: () => i18n.global.t("model.user.fullNameTh"), dataIndex: "refUserCommitteeTemp.fullNameTh", width: 200 }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refDocumentTypePerson"),
            dataIndex: "refUserCommitteeTemp.refDocumentTypePerson.value",
            inputProp: () => ({ list: callDocumentTypePerson, optLabel: "value" }),
            search: { name: "refUserCommitteeTemp.refDocumentTypePerson.id" },
            align: "center",
            width: 170
        }),
        createColumnInput({ title: () => i18n.global.t("model.user.idCard"), dataIndex: "refUserCommitteeTemp.idCard", align: "center", width: 130 }),
        createColumnDate({
            title: () => i18n.global.t("views.company.mgt.tab.approveDate"),
            dataIndex: "lastStatus.approve.0.statusDatetime",
            align: "center",
            width: 130
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callUserRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center",
            width: 110
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRequest.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callUserRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center",
            width: 100
        })
    ];
};

export const createField = ({ props, data, refs, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldDesc({ props, data, key, isLoading }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userRequest.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refUserCommittee
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.userRequest.refRequestType")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1"].includes(value?.key)) {
                                                const { createForm } = require("./tab3.logic");
                                                cloneUserCommittee({
                                                    model: {
                                                        ...createForm({ props, data, refs }),
                                                        id: model.id,
                                                        version: model.version,
                                                        isActive: model.isActive,
                                                        refStatus: model.refStatus,
                                                        refRequestDoc: model.refRequestDoc
                                                    }
                                                });
                                            } else {
                                                cloneUserCommittee({ model, id: model.refUserCommittee?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callUserRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refUserCommittee`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.company.mgt.tab.3.title"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refUserCommittee,
                            "onUpdate:value": value => {
                                const oldValue = model.refUserCommittee;
                                model.refUserCommittee = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("views.company.mgt.tab.3.title") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneUserCommittee({ model, id: value?.id }),
                                        onCancel: () => {
                                            model.refUser = oldValue;
                                        }
                                    });
                                } else {
                                    cloneUserCommittee({ model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callUserCommittee({ searchQuery, parentUsername: store.state.resource.auth.info.user.username }),
                            optLabel: "fullNameTh",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.fullNameTh`) }
            }),
            ...createFieldUserCommittee({ props, data, key: `${prefix}refUserCommitteeTemp`, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (
                    <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}refUserCommitteeTemp.addresses.0`}
                        isLoading={isLoading.value}
                    ></Address>
                )
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}refUserCommitteeTemp.attachments`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            }
        ]
    });
};

export const createFieldUserCommittee = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldUser2({ props, data, key, isLoading }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}fax`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.fax"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.fax,
                            "onUpdate:value": value => (model.fax = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}email`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.email,
                            "onUpdate:value": value => (model.email = value),
                            disabled: viewOnly,
                            onBlur: () => useForm.validate(field.key).catch(() => {})
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const cloneUserCommittee = ({ model, id }) => {
    if (id) {
        callUserCommitteeFull({ id }).then(user => {
            const refUserCommitteeTemp = copyForm({ form: { ...user } });
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refUserCommitteeTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const onLinkIdCard = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return d => {
        const result = [];
        if ((model.refUserCommitteeTemp.idCard || "") !== (d?.idCard || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("views.register.idCard")
                })
            );
        if ((model.refUserCommitteeTemp.birthDate || "") !== (d?.birthDate || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("model.user.birthDate")
                })
            );
        if ((model.refUserCommitteeTemp.refNationality?.value || "") !== (d?.nationalityDesc || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("model.user.refNationality")
                })
            );
        if ((model.refUserCommitteeTemp.refTitle?.value || "") !== (d?.titleName || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("model.user.refTitle")
                })
            );
        if ((model.refUserCommitteeTemp.firstNameTh || "") !== (d?.firstNameTh || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("model.user.firstNameTh")
                })
            );
        if ((model.refUserCommitteeTemp.middleNameTh || "") !== (d?.middleNameTh || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("model.user.middleNameTh")
                })
            );
        if ((model.refUserCommitteeTemp.lastNameTh || "") !== (d?.lastNameTh || ""))
            result.push(
                i18n.global.t("views.register.linkWrong", {
                    text: i18n.global.t("model.user.lastNameTh")
                })
            );
        model.lastStatus.forOfficeRemark[0].remark = result.join("\r\n");
    };
};